import { render, staticRenderFns } from "./LayoutTab.vue?vue&type=template&id=da404cb6&scoped=true&"
import script from "./LayoutTab.vue?vue&type=script&lang=js&"
export * from "./LayoutTab.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTab.vue?vue&type=style&index=0&id=da404cb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da404cb6",
  null
  
)

export default component.exports